var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ml-0 unselectable",class:{clickable: !_vm.disabled},attrs:{"disabled":_vm.disabled,"color":"transparent","text-color":_vm.disabled ? 'grey' : 'msr',"data-cy":"overlay-data-chip","small":""},nativeOn:{"click":function($event){_vm.disabled ? null : _vm.$emit('click')}}},[_c('v-avatar',{staticClass:"mr-0"},[_c('v-icon',{attrs:{"color":_vm.disabled ? 'grey lighten-1' : 'msr',"small":""}},[_vm._v("\n        edit\n      ")])],1),_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/OverlayDataChip.vue?vue&type=template&id=1279de78&scoped=true&
// module id = 1769
// module chunks = 5